import { registerLocaleData } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import localeEN from '@angular/common/locales/en';
import localeENExtra from '@angular/common/locales/extra/en';
import localeITExtra from '@angular/common/locales/extra/it';
import localeIT from '@angular/common/locales/it';
import { LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule, Title } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LocalStorageTodoService } from "app/admin/shared/services/localstorage/localstorage-todo.service";
import { NotificationService } from 'app/admin/shared/services/pcode/notification/notification.service';
import { ServicesModule } from "app/admin/shared/services/services.module";
import { AdminSharedModule } from "app/admin/shared/shared.module";
import { ToastrModule } from 'ngx-toastr';
import { NgxUploaderModule } from 'ngx-uploader';
import * as R from 'ramda';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app.routing";
import { AppState, InternalStateType } from "./app.service";
import { GlobalState } from "./app.state";
import { AjaxLoaderService } from './shared/services/ajaxLoader.service';
import { JwtHttpInterceptor } from './shared/services/jwtHttpInterceptor.service';

const USER_LOCALE = localStorage.getItem('user_lang') || 'it';
switch (USER_LOCALE)
{
    case 'it':
        registerLocaleData(localeIT, localeITExtra);
        break;

    case 'en':
        registerLocaleData(localeEN, localeENExtra);
        break;

    default:
        registerLocaleData(localeIT, localeITExtra);
        break;
}

const APP_PROVIDERS = [
    { provide: LOCALE_ID, useValue: USER_LOCALE },
    { provide: HTTP_INTERCEPTORS, useClass: JwtHttpInterceptor, multi: true },
    AppState,
    GlobalState,
    Title,
    LocalStorageTodoService,
    NotificationService,
    AjaxLoaderService
];

export type StoreType = {
    state: InternalStateType;
    restoreInputValues: () => void;
    disposeOldHosts: () => void;
};

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient)
{
    return new MultiTranslateHttpLoader(http, [
        { prefix: "/assets/translate/core/", suffix: ".json" },
        { prefix: "/assets/translate/admin/", suffix: ".json" },
        { prefix: "/assets/translate/webapp/", suffix: ".json" }
    ]);
}

export class MultiTranslateHttpLoader implements TranslateLoader
{
	constructor(private http: HttpClient, public resources: { prefix: string; suffix: string }[] = [{ prefix: '/assets/translate/', suffix: '.json' }]) { }

	public getTranslation(lang: string)
	{
		return forkJoin(this.resources.map(config =>
		{
			return this.http.get(config.prefix + lang + config.suffix);
		}))
			.pipe(map(response =>
			{
				return response.reduce((a, b) =>
				{
					return R.mergeDeepLeft(a, b);
				});
			}));
	}
}

export function getToken(): string
{
    return localStorage.getItem('access_token');
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ServicesModule,
        AdminSharedModule.forRoot(),
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
            preventDuplicates: true
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NgxUploaderModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })], providers: [APP_PROVIDERS, provideHttpClient(withInterceptorsFromDi())] })

export class AppModule
{
    constructor(public appState: AppState)
    {
    }
}
